import { useState } from 'react'

import { strings } from '@/lib/strings'
import { getStoredTheme, setTheme, THEMES, type Theme } from '@/lib/theme'

const LABELS: Record<Theme, string> = {
  light: strings.theme.light,
  dark: strings.theme.dark,
  system: strings.theme.system,
}

export function ThemeToggle() {
  const [theme, setCurrent] = useState<Theme>(() => getStoredTheme())

  function handleChange(next: Theme) {
    setTheme(next)
    setCurrent(next)
  }

  return (
    <label className="flex items-center gap-2 text-sm text-muted">
      <span className="sr-only">{strings.theme.label}</span>
      <select
        aria-label={strings.theme.label}
        value={theme}
        onChange={(event) => handleChange(event.target.value as Theme)}
        className="rounded-md border border-border bg-surface px-2 py-1 text-fg"
      >
        {THEMES.map((option) => (
          <option key={option} value={option}>
            {LABELS[option]}
          </option>
        ))}
      </select>
    </label>
  )
}
